import { ColorFunctions } from './types.js';

const TextColorKeyMap = {
    [ColorFunctions.PRIMARY]: "primary",
    [ColorFunctions.SECONDARY]: "secondary",
    [ColorFunctions.POSITIVE]: "positive",
    [ColorFunctions.CAUTION]: "caution",
    [ColorFunctions.NEGATIVE]: "negative"
};
const BackgroundColorKeyMap = {
    [ColorFunctions.PRIMARY]: "primaryBackground",
    [ColorFunctions.SECONDARY]: "secondaryBackground",
    [ColorFunctions.POSITIVE]: "positiveBackground",
    [ColorFunctions.CAUTION]: "cautionBackground",
    [ColorFunctions.NEGATIVE]: "negativeBackground"
};

export { BackgroundColorKeyMap, TextColorKeyMap };
